function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  /* Reset default p tag style */\n  margin: ", "px;\n\n  color: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { space, layout, color, typography, textStyle, flex } from 'styled-system';
import { getTheme } from '../Theme';
var TextBase = styled.p(_templateObject(), getTheme('space.0'), getTheme('colors.current'), getTheme('letterSpacings.normal'), getTheme('lineHeights.base'), space, layout, flex, textStyle, color, typography);

var Text = function Text(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(TextBase, props);
};

export default Text;